<app-help-header></app-help-header>
<main>
  <div class="content">
    <div class="container help-content">
      <div class="row">
        <div class="col-md-3">
          <app-help-menu class="hidden-sm"></app-help-menu>
        </div>
        <div class="col-md-9">
          <!-- Purchase Plan -->
          <section #h_PurchasePlan [@fadeInAnimation]>
            <h3 translate id="item-3-2">Purchase Plan</h3>
            <!-- <div translate class="sum">
              You can review your purchase of package/license details in the past.
            </div> -->
            <div class="list">
              <h5 translate>Web Purchase</h5>
              <div class="section">
                <ul>
                  <li translate>According to your device number and demand, purchase suitable plan.</li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-purchasePlan.jpg">
                </div>
              </div>
            </div>
            <div class="list">
              <h5 translate>APP Purchase</h5>
              <div class="section">
                <ul>
                  <li translate>Download PowerPanel Cloud app and use the in-app purchase function.</li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-purchasePlan-2.jpg">
                </div>
              </div>
            </div>

          </section>
        </div>

      </div>
    </div>
  </div>
</main>
